import { render, staticRenderFns } from "./SimilarAnnotation.vue?vue&type=template&id=d8dcc9c0&scoped=true"
import script from "./SimilarAnnotation.vue?vue&type=script&lang=js"
export * from "./SimilarAnnotation.vue?vue&type=script&lang=js"
import style0 from "./SimilarAnnotation.vue?vue&type=style&index=0&id=d8dcc9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dcc9c0",
  null
  
)

export default component.exports